import React from 'react'
import SignupForm from '../components/SignupForm'

const Signup = () => {
    return (
      <>
        <h1> This is my signup page </h1>
        <SignupForm></SignupForm>
      </>
    )
  }
  
  export default Signup